import type { FC } from 'react'

import { useCommandState } from 'cmdk'

import { CommandItem } from '@/components/ui/command.tsx'

export interface Props {
  onSelect: (name: string) => void
  loading: boolean
}

export const CommandCreateItem: FC<Props> = ({ onSelect, loading }) => {
  const query = useCommandState((state) => {
    return state.filtered.count === 0 && state.search
  })

  if (!query || !onSelect) return null

  return (
    <CommandItem
      className="cursor-pointer justify-center py-3"
      forceMount
      value="+create+"
      onSelect={() => onSelect(query)}
    >
      {loading ? `Creating "${query}" type...` : `+ Create "${query}" type`}
    </CommandItem>
  )
}
